// Random meeting-title generator — playful names blending astronomy and tech.
// Powers the schedule drawer's "surprise me" dice. Pure, no deps.

const THEMES = [
  'Nebula',
  'Quasar',
  'Andromeda',
  'Orion',
  'Pulsar',
  'Photon',
  'Quantum',
  'Cosmos',
  'Supernova',
  'Aurora',
  'Eclipse',
  'Meridian',
  'Zenith',
  'Horizon',
  'Neutron',
  'Stellar',
  'Lunar',
  'Solar',
  'Comet',
  'Vertex',
  'Kernel',
  'Cipher',
  'Halcyon',
  'Nova',
  'Galaxy',
  'Celestial',
  'Astral',
  'Cascade',
];

const KINDS = [
  'Sync',
  'Standup',
  'Sprint Planning',
  'Design Review',
  'Roadmap Sync',
  'Retrospective',
  'Kickoff',
  'Deep Dive',
  'Sprint Review',
  'Planning',
  'Huddle',
  'Working Session',
  'Brainstorm',
  'Demo',
  'Strategy Session',
  'Backlog Grooming',
  'Architecture Review',
  'Launch Sync',
];

function pick<T>(xs: readonly T[]): T {
  const v = xs[Math.floor(Math.random() * xs.length)];
  if (v === undefined) throw new Error('pick: empty pool');
  return v;
}

/** A fresh random title, avoiding `avoid` (the current value) when it can. */
export function randomMeetingTitle(avoid = ''): string {
  for (let i = 0; i < 8; i++) {
    const t = `${pick(THEMES)} ${pick(KINDS)}`;
    if (t !== avoid) return t;
  }
  return `${pick(THEMES)} ${pick(KINDS)}`;
}
